import { render } from "./FilterJenisApi.vue?vue&type=template&id=ce1a9b70"
import script from "./FilterJenisApi.vue?vue&type=script&lang=js"
export * from "./FilterJenisApi.vue?vue&type=script&lang=js"
script.render = render

export default script